/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SummaryofSalesbyYearAddComponent
 * Purpose		: This component retrieves specified record and shows details.
 * Dependency	: SummaryofSalesbyYearService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit, HostBinding, EventEmitter, Input, Output,
         trigger, transition, animate,
         style, state } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';
import { SummaryofSalesbyYearData, SummaryofSalesbyYearService }  from './SummaryofSalesbyYear.service';


@Component({
  template: require('./SummaryofSalesbyYearDetails.component.html'),
  providers: [SummaryofSalesbyYearService
	
	],
  animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class SummaryofSalesbyYearDetailsComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }

	objSummaryofSalesbyYear: SummaryofSalesbyYearData;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	

	constructor(private route: ActivatedRoute, 
		private router: Router,
		private toastr: ToastsManager,
		private SummaryofSalesbyYearService: SummaryofSalesbyYearService

	) {
		// this.id = parseInt(params.get('id'));
		this.objSummaryofSalesbyYear = new SummaryofSalesbyYearData();
	}

	ngOnInit() {
		this.route.params
		// (+) converts string 'id' to a number
		// .switchMap((params: Params) => this.SummaryofSalesbyYearService.getByID(+params['id']))
		.switchMap((params: Params) => this.SummaryofSalesbyYearService.getByID(params['id']))
		.subscribe((item: SummaryofSalesbyYearData) => this.objSummaryofSalesbyYear = item);
		this.getLookups();
	}

	deleteSummaryofSalesbyYear(id: string) {
		if (window.confirm('Are you sure you want to delete this SummaryofSalesbyYear?') == true) 
		{
			this.SummaryofSalesbyYearService.deleteSummaryofSalesbyYear(this.objSummaryofSalesbyYear.ShippedDate.toString())
			.subscribe(record => this.router.navigate(['/SummaryofSalesbyYear']),
				error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { console.log('SummaryofSalesbyYear record deleted successfully...'); }
			);
		}
	}
	gotoSummaryofSalesbyYearEdit() {
		this.router.navigate(['/SummaryofSalesbyYear', this.objSummaryofSalesbyYear.ShippedDate]);
	}

	gotoSummaryofSalesbyYear() {
		this.router.navigate(['/SummaryofSalesbyYear']);
	}


	getLookups() {

	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/SummaryofSalesbyYear/SummaryofSalesbyYearDetails.component.ts